import { useCIQQuery } from "hooks/ciq-gql-hooks";
import { GET_FEATURES_DATA_BY_IDS_FOR_REQUEST_DURATION } from "services/graphQL/ciq-queries";
import { useContext } from "react";
import { ProjectContext } from "context/ProjectProvider";
import { IMaterial } from "../type-definitions";

function useRequestDurationsDataProvider(selectedIds: string[]) {
  const { gqlClientForProject } = useContext(ProjectContext);

  const { data, loading } = useCIQQuery<{
    feature_instance: IMaterial[];
  }>(GET_FEATURES_DATA_BY_IDS_FOR_REQUEST_DURATION, {
    client: gqlClientForProject,
    variables: {
      featureIds: selectedIds
    }
  });

  return { data: data ?? null, loading };
}

export default useRequestDurationsDataProvider;
